import React from "react";
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import DepartmentSelfEvaluationIndicatorManager from "@/components/indicators/DepartmentSelfEvaluationIndicatorManager";

const DepartmentSelfEvaluationIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <DepartmentSelfEvaluationIndicatorManager />
      </Box>
    </Box>
  );
};

export default DepartmentSelfEvaluationIndicatorPage;
